// extracted by mini-css-extract-plugin
export default {"app":"App_app__Vk6B+","body":"App_body__OuReX"};